var exports = {
  "or": "VoiceParticipantTile.module__cursorPointer___TDZIRz",
  "yy": "VoiceParticipantTile.module__watchStreamOverlay___TDZIRz",
  "R6": "VoiceParticipantTile.module__watchStreamButtons___TDZIRz",
  "kV": "VoiceParticipantTile.module__watchStreamButton___TDZIRz",
  "LY": "VoiceParticipantTile.module__watchStreamButtonLabel___TDZIRz",
  "MO": "VoiceParticipantTile.module__watchStreamSecondaryButton___TDZIRz",
  "gk": "VoiceParticipantTile.module__streamInfoHud___TDZIRz",
  "FI": "VoiceParticipantTile.module__streamEndedOverlay___TDZIRz",
  "Zz": "VoiceParticipantTile.module__screenShareBufferingFrame___TDZIRz",
  "Wo": "VoiceParticipantTile.module__streamEndedContent___TDZIRz",
  "$k": "VoiceParticipantTile.module__streamEndedTitle___TDZIRz",
  "BL": "VoiceParticipantTile.module__streamEndedButton___TDZIRz",
  "Ec": "VoiceParticipantTile.module__avatarRing___TDZIRz",
  "Gi": "VoiceParticipantTile.module__avatarRingSpeaking___TDZIRz",
  "kA": "VoiceParticipantTile.module__tileAvatarRing___TDZIRz",
  "z3": "VoiceParticipantTile.module__focusOverlay___TDZIRz",
  "gD": "VoiceParticipantTile.module__focusOverlayIcon___TDZIRz",
  "yI": "VoiceParticipantTile.module__videoDisabledOverlay___TDZIRz",
  "xS": "VoiceParticipantTile.module__videoDisabledIcon___TDZIRz",
  "if": "VoiceParticipantTile.module__participantIconMuted___TDZIRz",
  "Yc": "VoiceParticipantTile.module__participantIconRed___TDZIRz",
  "io": "VoiceParticipantTile.module__participantIconWhite___TDZIRz",
  "Gl": "VoiceParticipantTile.module__participantNameText___TDZIRz",
  "Zi": "VoiceParticipantTile.module__participantConnectionText___TDZIRz",
  "P4": "VoiceParticipantTile.module__tilePillIcon___TDZIRz",
  "cj": "VoiceParticipantTile.module__streamAudioSlotMuted___TDZIRz",
  "Sr": "VoiceParticipantTile.module__avatarFlexShrink___TDZIRz",
  "iW": "VoiceParticipantTile.module__previewPopover___TDZIRz",
  "OG": "VoiceParticipantTile.module__frozenFrame___TDZIRz",
  "Wz": "VoiceParticipantTile.module__dimmedLastFrame___TDZIRz",
  "xR": "VoiceParticipantTile.module__cornerBufferingIndicator___TDZIRz",
  "kJ": "VoiceParticipantTile.module__screensharePreviewBackground___TDZIRz",
  "A": "VoiceParticipantTile.module__streamPreviewUnavailableSurface___TDZIRz",
  "Ae": "VoiceParticipantTile.module__focusedPlaceholderScreenSurface___TDZIRz",
  "SQ": "VoiceParticipantTile.module__focusedPlaceholderCameraOverlay___TDZIRz",
  "xh": "VoiceParticipantTile.module__focusedPlaceholderIconLayer___TDZIRz",
  "Iy": "VoiceParticipantTile.module__focusedPlaceholderIcon___TDZIRz",
  "uA": "VoiceParticipantTile.module__focusedPlaceholderLiveBadge___TDZIRz",
  "mf": "VoiceParticipantTile.module__focusedPlaceholderAvatarDimmed___TDZIRz",
  "vB": "VoiceParticipantTile.module__selfStreamOverlay___TDZIRz",
  "Ft": "VoiceParticipantTile.module__paused___TDZIRz",
  "xz": "VoiceParticipantTile.module__selfStreamPreviewPaused___TDZIRz",
  "ck": "VoiceParticipantTile.module__pausedIcon___TDZIRz",
  "Ok": "VoiceParticipantTile.module__pausedText___TDZIRz",
  "I5": "VoiceParticipantTile.module__pausedSubtext___TDZIRz",
  "AS": "VoiceParticipantTile.module__watchStreamPrimaryButton___TDZIRz",
  "DE": "VoiceParticipantTile.module__groupExpandPillSlot___TDZIRz",
  "GX": "VoiceParticipantTile.module__groupExpandPillSign___TDZIRz",
};

module.exports = exports;
